// Copyright (c) Docugami, Inc. All rights reserved.

import { Icon, IContextualMenuItem } from "@fluentui/react";
import { useDgAuth } from 'hooks/DgAuthentication';
import { NavigationType, useNavigationService } from './navigationService';
import { MenuItem } from '../components/shell/presentation/MainMenu';

export function useUserProfileMenuItems(): MenuItem[] {
    const { isAuthenticated, isOrganizationAdmin } = useDgAuth();
    const navServices = useNavigationService();

    var items: MenuItem[] = [];
    var supportItems: IContextualMenuItem[] = [];
    var helpItems: IContextualMenuItem[] = [];

    const iconStyle = { root: { fontSize: '16px', fontWeight: '300', margin: '0 5px' } };
    const logoutIcon = <Icon iconName='SignOut' styles={iconStyle} />;
    const manageIcon = <Icon iconName='Group' styles={iconStyle} />;
    const developerIcon = <Icon iconName='Embed' styles={iconStyle} />;
    const feedbackIcon = <Icon iconName='Feedback' styles={iconStyle} />;
    const linkIcon = <Icon iconName='Link' styles={iconStyle} />;

    items.push({
        title: 'Manage Account',
        icon: manageIcon,
        listItems: [],
        onClick: () => navServices.navToAccountPage(NavigationType.PushNewPage)
    });

    if (isOrganizationAdmin) {
        items.push({
            title: 'Developer Playground',
            icon: developerIcon,
            listItems: [],
            onClick: () => navServices.navToDeveloperHub()
        });
    }

    supportItems.push(
        {
            key: 'tou',
            text: 'Terms of Use',
            url: 'https://www.docugami.com/terms',
            target: '_blank'
        }
        ,
        {
            key: 'privacy_policy',
            text: 'Privacy Policy',
            url: 'https://www.docugami.com/privacy',
            target: '_blank'
        }
        ,
        {
            key: 'docugami_website',
            text: 'Docugami.com',
            url: 'https://www.docugami.com',
            target: '_blank'
        }
    );

    items.push({
        title: 'Additional Links',
        icon: linkIcon,
        listItems: supportItems
    });

    helpItems.push(
        {
            key: 'help',
            text: 'Help Center',
            url: 'https://help.docugami.com/home',
            target: '_blank'
        }
        ,
        {
            key: 'feedback',
            text: 'Contact Support',
            onClick: () => {
                const userback = (window as any).Userback;
                if (!!userback) {
                    userback.open();
                }
            },
        }

    );

    items.push({
        title: 'Help and Feedback',
        icon: feedbackIcon,
        listItems: helpItems
    });

    if (isAuthenticated) {
        items.push({
            title: 'Log Out',
            icon: logoutIcon,
            listItems: [],
            onClick: () => navServices.logout()
        });
    }

    return items;
}